import { Address } from '@getpopsure/public-models';

export function inlinedFormattedAddress(input: Address): string {
  return `${input.street} ${input.houseNumber}, ${input.postcode} ${input.city}`;
}
